<section class="events-main-wrap" *ngIf="eventResults.length > 0">

  <section class="events-wrap">

    <div class="selected-league">
      <ng-container *ngFor="let eventResult of eventResults; let i = index">
        <ng-container
          *ngIf="i==0 || eventResults[i-1].eventDateTime.getDate() != eventResult.eventDateTime.getDate() || (viewConfigurations.showAllEventsButtonOnSelectedRegion && eventResult.regionId && !eventResult.competitionId && eventResults[i-1].competitionId != eventResults[i].competitionId)">
          <div class="row bet-type-name-wrap">
            <div class="col col1"></div>
            <div class="col col2">
              <ng-container *ngFor="let scoreGroup of scoreGroups; let i = index">
                <div class="bet-type-col">{{scoreGroup.name}}</div>
              </ng-container>
            </div>
            <div class="col col-bets"></div>
          </div>

          <div class="row bet-info-wrap">
            <div class="col col1">
              <span class="competition-name"
                *ngIf="viewConfigurations.showAllEventsButtonOnSelectedRegion && eventResult.regionId && !eventResult.competitionId">{{eventResult.competitionName}}</span>
              <span>{{eventResult.eventDate}}</span>
            </div>
            <div class="col col-bets"></div>
          </div>

        </ng-container>
        <app-results-event [eventResult]="eventResult" [scoreGroups]="scoreGroups"></app-results-event>
      </ng-container>
    </div>
  </section>
</section>
